import React from "react";

function Footer({ children }) {
  return <div className="Footer"></div>;
}

export default Footer;
